import { render, staticRenderFns } from "./GameCreation.vue?vue&type=template&id=d96e1d44&scoped=true"
import script from "./GameCreation.vue?vue&type=script&lang=js"
export * from "./GameCreation.vue?vue&type=script&lang=js"
import style0 from "./GameCreation.vue?vue&type=style&index=0&id=d96e1d44&prod&lang=scss&scoped=true"
import style1 from "./GameCreation.vue?vue&type=style&index=1&id=d96e1d44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.19_css-loader@6.10.0_webpack@5.90.3__lodash@4._3b565607f4984d8a9a80d55750768552/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96e1d44",
  null
  
)

export default component.exports